/**
 * Shared ESC close stack — module-level singleton.
 *
 * Used by EntitySheet, FormFieldMenu, and any other component that
 * needs to handle Escape key in a layered/stacked manner.
 * The topmost (most recently pushed) handler fires first.
 */

export const escStack: (() => void)[] = [];

function handleGlobalEsc(e: KeyboardEvent) {
  if (e.key === 'Escape' && escStack.length > 0) {
    escStack[escStack.length - 1]();
  }
}

if (typeof document !== 'undefined') {
  document.addEventListener('keydown', handleGlobalEsc);
}
